import config from '../../config';

export default {
  url: `${config.api.baseURL}/modules`,
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/list.js